import { Chip } from "@mui/material";
import DetailView, {
  DetailCard,
  DetailField,
  emailValue,
  text,
  yesNo,
} from "../../Shared/DetailView/DetailView";

// Ficha de un partner o fabricante, con el formato común de DetailView
export default function PartnerDetail(props: { row: any }) {
  const { row } = props;
  return (
    <DetailView
      title={row.name}
      badges={
        <>
          {row.is_part ? <Chip size="small" color="info" label="Partner" /> : null}
          {row.is_maker ? <Chip size="small" color="info" label="Fabricante" /> : null}
        </>
      }
    >
      <DetailCard title="Identificación">
        <DetailField label="Razón social">{text(row.name)}</DetailField>
        <DetailField label="CIF">{text(row.cif)}</DetailField>
      </DetailCard>

      <DetailCard title="Contacto">
        <DetailField label="Email">{emailValue(row.email)}</DetailField>
        <DetailField label="Teléfono">{text(row.telephone)}</DetailField>
      </DetailCard>

      <DetailCard title="Tipo">
        <DetailField label="Partner">{yesNo(row.is_part)}</DetailField>
        <DetailField label="Fabricante">{yesNo(row.is_maker)}</DetailField>
      </DetailCard>
    </DetailView>
  );
}
